export default "__VITE_ASSET__DIlTkjsF__"